import React, { useState, useEffect, createContext } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./Components/Header/Header";
import { User_Login } from "./Components/User_Login/Login";
import { Otp } from "./Components/User_Login/Otp";
import Layout from "./Components/Layout/Layout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { useWebSocket } from "./hooks/useWebSocket";
import SessionHandler from "./Components/sessionHandler/SessionHandler";
import { connect, useDispatch } from "react-redux";
import { setMmRfqFormData } from "./Redux/MMRfq/actions";
import { useBeforeUnloadPrompt } from "./hooks/useUnsavedChangesPrompt";
import { createStructuredSelector } from "reselect";
import { getAutoPopulateCoRFQDetailsForMMRFQApi } from "./AccountManagement/Services/MMRfqForm";
import { mmRfqFormDataSelector } from "./Redux/MMRfq/Selector";
import { DownTimeScreen } from "./Components/User_Login/DownTimeScreen";
export const WebsocketContext = createContext(null);

function App() {
    const { messages, isConnected } = useWebSocket();
    useEffect(() => {
        console.log("WebSocket messages:", messages);
    }, [messages]);

    const [isLoggedIn, setIsLoggedIn] = useState(
        localStorage.getItem("isLoggedIn") === "true"
    );
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [updateIsReadStatus, setUpdateIsReadStatus] =
        useState<boolean>(false);

    const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

    useEffect(() => {
        const handleStorageChange = () => {
            setIsLoggedIn(localStorage.getItem("isLoggedIn") === "true");
        };
        window.addEventListener("storage", handleStorageChange);
        return () => window.removeEventListener("storage", handleStorageChange);
    }, []);
    // useBeforeUnloadPrompt(
    //   true,
    //   "You have unsaved changes. Are you sure you want to leave?"
    // );

    return (
        <BrowserRouter basename="/">
            <WebsocketContext.Provider
                value={{ messages, updateIsReadStatus, setUpdateIsReadStatus }}
            >
                <SessionHandler />
                <ToastContainer />
                <Header
                    toggleSidebar={toggleSidebar}
                    updateIsReadStatus={updateIsReadStatus}
                    setUpdateIsReadStatus={setUpdateIsReadStatus}
                    webSocketMessage={messages} // Pass messages to Header
                    isLoggedIn={isLoggedIn}
                />

                <Routes>
                    {isLoggedIn ? (
                        <>
                            <Route
                                path="/layout"
                                element={<Navigate to="/layout/Dashboard" />}
                            />
                            <Route
                                path="/layout/:page"
                                element={
                                    <Layout
                                        isSidebarOpen={isSidebarOpen}
                                        toggleSidebar={toggleSidebar}
                                        updateIsReadStatus={updateIsReadStatus}
                                        setUpdateIsReadStatus={
                                            setUpdateIsReadStatus
                                        }
                                    />
                                }
                            />
                            <Route
                                path="*"
                                element={<Navigate to="/layout/Dashboard" />}
                            />
                        </>
                    ) : (
                        <>
                            <Route
                                path="/"
                                element={
                                    <User_Login setIsLoggedIn={setIsLoggedIn} />
                                }
                            />
                            <Route path="*" element={<Navigate to="/" />} />
                        </>
                    )}
                    <Route
                        path="/DownTimeScreen"
                        element={<DownTimeScreen />}
                    />
                    <Route
                        path="/otp"
                        element={<Otp setIsLoggedIn={setIsLoggedIn} />}
                    />
                </Routes>
            </WebsocketContext.Provider>
        </BrowserRouter>
    );
}

export default App;
